import type { ReactNode } from 'react';
import AppLayout from './AppLayout';

export { PROJECT_TABS, SETTINGS_LINKS, navItemClass } from './nav-item';

export const PAGE_ROOT = 'min-h-[100dvh] bg-background';
export const PAGE_INSET = 'w-full px-4 py-6';

export function PageFrame({ children }: { children: ReactNode }) {
  return <AppLayout>{children}</AppLayout>;
}
